module.exports = __webpack_public_path__ + "static/fonts/notokr-regular.031547c.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/affiliatecard/font/notokr-regular.woff
// module id = ZaBv
// module chunks = 0